/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_Have_AccountInputs */

const en_guest_book_have_account = /** @type {(inputs: Guest_Book_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have an account?`)
};

const pl_guest_book_have_account = /** @type {(inputs: Guest_Book_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masz konto?`)
};

/**
* | output |
* | --- |
* | "Have an account?" |
*
* @param {Guest_Book_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_have_account = /** @type {((inputs?: Guest_Book_Have_AccountInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_Have_AccountInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_have_account(inputs)
	return en_guest_book_have_account(inputs)
});